import types from './notifyTypes';

export const setNotifyStatus = status => ({
  type: types.SET_NOTIFY_STATUS,
  payload: status,
});
